import { FC, Fragment } from 'react'

type StrippedFragmentProps = {

}

export const StrippedFragment: FC<StrippedFragmentProps> = (props) => {
  const { children } = props

  return (
    <Fragment>{ children }</Fragment>
  )
}
